export default "__VITE_ASSET__DAiU2vtg__"